import React, { useEffect } from 'react';
import styled from '@mui/material/styles/styled';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import useAuth from '../../providers/Auth/Auth.provider';
import { useGetTenantAccountingSettingsQuery } from '../../redux/api/tenant/tenantApi';
import { useGetQBOClassTrackingQuery } from '../../redux/api/divisions/divisionsApi';

const HeaderContainer = styled(Grid)(() => ({
  backgroundColor: '#F3F4F6',
  border: '1px solid #E5E7EB',
  boxShadow: '0px 4px 12px 0px #00000005',
  color: '#9CA3AF',
  textTransform: 'uppercase',
  fontFamily: 'Poppins',
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '18px',
  padding: '7px 14px'
}));

const Header: React.FC<{
  selectedDivisionId?: string;
  hideQboClass?: boolean;
}> = ({ selectedDivisionId, hideQboClass = false }) => {
  const {
    getTenantSetting,
    data: { userData }
  } = useAuth();
  const { data: divisionAccountingSettings, isLoading } = useGetTenantAccountingSettingsQuery({
    divisionId: selectedDivisionId || userData?.defaultDivision.id || ''
  });
  const showServiceId = getTenantSetting('enable-service-id');

  const quickbooksEnabled = !!divisionAccountingSettings?.division_qbo_credentials?.id;

  const { data: qboPreferences = { classTrackingPerTxn: false, classTrackingPerTxnLine: false } } =
    useGetQBOClassTrackingQuery(selectedDivisionId || '', {
      skip: !selectedDivisionId || !quickbooksEnabled
    });

  if (showServiceId) {
    return (
      <HeaderContainer container item marginBottom="8px">
        <Grid item xs={2.5}>
          Service
        </Grid>
        <Grid item xs={1}>
          <Box>ID</Box>
        </Grid>
        {qboPreferences.classTrackingPerTxnLine && quickbooksEnabled && !hideQboClass && (
          <Grid item xs={1.5}>
            CLASS
          </Grid>
        )}
        <Grid item xs={2}>
          <Box>UNIT</Box>
        </Grid>
        <Grid item xs={1.5}>
          <Box marginLeft="5px">QTY</Box>
        </Grid>
        <Grid item xs={1.5}>
          <Box
            sx={{
              marginLeft: {
                sm: '10px'
              }
            }}
          >
            RATE
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            sx={{
              marginLeft: {
                sm: '20px'
              }
            }}
          >
            AMOUNT
          </Box>
        </Grid>
      </HeaderContainer>
    );
  }

  return (
    <HeaderContainer container item marginBottom="8px">
      <Grid item xs={3}>
        Service
      </Grid>
      {qboPreferences.classTrackingPerTxnLine && quickbooksEnabled && !hideQboClass && (
        <Grid item xs={2}>
          CLASS
        </Grid>
      )}
      <Grid item xs={2}>
        <Box
          sx={{
            marginLeft: {
              xs: '10px',
              sm: '5px'
            }
          }}
        >
          UNIT
        </Box>
      </Grid>
      <Grid item xs={1.5}>
        <Box
          sx={{
            marginLeft: {
              xs: '10px',
              sm: '5px'
            }
          }}
        >
          QTY
        </Box>
      </Grid>
      <Grid item xs={1.5}>
        <Box
          sx={{
            marginLeft: {
              sm: '10px'
            }
          }}
        >
          RATE
        </Box>
      </Grid>
      <Grid item xs={2}>
        <Box
          sx={{
            marginLeft: {
              sm: '20px'
            }
          }}
        >
          AMOUNT
        </Box>
      </Grid>
    </HeaderContainer>
  );
};

export default Header;
